/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_LimitedInputs */



/**
* | output |
* | --- |
* | "limited (draft/sealed) decks are not archived" |
*
* @param {Twda_Reason_LimitedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_limited = /** @type {((inputs?: Twda_Reason_LimitedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_LimitedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("les decks Limité (draft/sealed) ne sont pas archivés")
	if (locale === "es") return /** @type {LocalizedString} */ ("los mazos Limited (draft/sealed) no se archivan")
	if (locale === "pt") return /** @type {LocalizedString} */ ("decks Limited (draft/sealed) não são arquivados")
	if (locale === "it") return /** @type {LocalizedString} */ ("i mazzi Limited (draft/sealed) non vengono archiviati")
	return /** @type {LocalizedString} */ ("limited (draft/sealed) decks are not archived")
});